import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  isFetching: true,
  hasError: false,
  selectedMetric: window.conviva.module === 'APP' ? 'APP_PAGE_LOAD_TIME' : 'AUTOALERTVST',
  sensitivityMetricConfigList: [],
  sensitivityLogs: [],
  currentConfig: {},
  currentConfigErrorMsg: '',
  isLogsFetching: true,
  hasLogsError: false,
};

const switchMap = {};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.FETCHING] = (state, action) =>
  update(state, {
    isFetching: { $set: action.flag },
  });

switchMap[types.SENSITIVITY_LOGS_FETCHING] = (state, action) =>
  update(state, {
    isLogsFetching: { $set: action.flag },
  });

switchMap[types.SET_ERROR] = (state, action) =>
  update(state, {
    hasError: { $set: action.flag },
  });

switchMap[types.SET_LOGS_ERROR] = (state, action) =>
  update(state, {
    hasLogsError: { $set: action.flag },
  });

switchMap[types.SET_SENSITIVITY_METRIC_CONFIG_LIST] = (state, action) =>
  update(state, {
    sensitivityMetricConfigList: { $set: action.payload },
  });

switchMap[types.SET_SELECTED_METRIC] = (state, action) =>
  update(state, {
    selectedMetric: { $set: action.payload },
  });

switchMap[types.SET_SENSITIVITY_LOGS] = (state, action) =>
  update(state, {
    sensitivityLogs: { $set: action.payload },
  });

switchMap[types.SET_CURRENT_CONFIG] = (state, action) =>
  update(state, {
    currentConfig: { $set: action.payload },
  });

switchMap[types.UPDATE_CURRENT_CONFIG] = (state, action) => {
  return update(state, {
    currentConfig: {
      [action.payload.key]: { $set: action.payload.value },
    },
  });
};

switchMap[types.SET_SENSITIVITY_CONFIG_ERROR_MSG] = (state, action) =>
  update(state, {
    currentConfigErrorMsg: { $set: action.errorMsg },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
